import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
import useApp from './useApp';
import useApi from './useApi';
export default (function (path) {
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      interested = _useState2[0],
      setInterested = _useState2[1];

  var _useApi = useApi({
    disableAppLoader: true
  }),
      _useApi2 = _slicedToArray(_useApi, 5),
      response = _useApi2[0],
      setRequest = _useApi2[1],
      loading = _useApi2[2],
      error = _useApi2[3],
      reset = _useApi2[4];

  var _useApp = useApp(),
      displaySnackMessage = _useApp.displaySnackMessage;

  var toggle = function toggle() {
    setRequest({
      method: interested ? 'del' : 'post',
      path: "".concat(path, "register_interest/")
    });
  };

  useEffect(function () {
    if (response !== null || error) {
      return;
    }

    setInterested(!interested);
    displaySnackMessage(interested ? 'Interest unregistered' : 'Interest registered', 'success');
    reset();
  }, [response]);
  return [interested, loading, toggle, setInterested];
});